import { gql, useQuery } from '@apollo/client';
import { ModalProps } from '@chakra-ui/react';
import * as React from 'react';

import { LikesModal } from '@/components/Post/components/LikesModal';

import {
  CommentLikesModal_GetComment,
  CommentLikesModal_GetCommentVariables,
} from './graphql-types/CommentLikesModal_GetComment';

const GET_COMMENT = gql`
  query CommentLikesModal_GetComment($commentId: String!) {
    comment(input: { id: $commentId }) {
      result {
        _id
        reactions {
          _id
          ...LikesModal_ReactionFragment
        }
      }
    }
  }
  ${LikesModal.reactionFragment}
`;

export const CommentLikesModal: React.FC<
  Omit<ModalProps, 'children'> & {
    commentId: string;
  }
> = ({ commentId, ...modalProps }) => {
  const { data } = useQuery<
    CommentLikesModal_GetComment,
    CommentLikesModal_GetCommentVariables
  >(GET_COMMENT, {
    variables: { commentId: commentId },
    skip: !modalProps.isOpen,
    fetchPolicy: 'cache-and-network',
  });

  return (
    <LikesModal
      {...modalProps}
      reactions={data?.comment?.result?.reactions || []}
    />
  );
};
